<app-bread-crumb></app-bread-crumb>

<div class="dividend-account-wrapper">
    <main>

        <!-- ──────────────────────────────── Stepper ──────────────────────────────── -->
        <div class="stepper">
            <div class="step-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                <div class="step-circle">
                    <span *ngIf="currentStep <= 1">1</span>
                    <span *ngIf="currentStep > 1" class="check-icon">✓</span>
                </div>
                <div class="step-label">填寫基本資料</div>
            </div>

            <div class="step-line" [class.completed]="currentStep > 1"></div>

            <div class="step-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
                <div class="step-circle">
                    <span *ngIf="currentStep <= 2">2</span>
                    <span *ngIf="currentStep > 2" class="check-icon">✓</span>
                </div>
                <div class="step-label">身份驗證</div>
            </div>

            <div class="step-line" [class.completed]="currentStep > 2"></div>

            <div class="step-item" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
                <div class="step-circle">
                    <span *ngIf="currentStep <= 3">3</span>
                    <span *ngIf="currentStep > 3" class="check-icon">✓</span>
                </div>
                <div class="step-label">申請電子帳單</div>
            </div>

            <div class="step-line" [class.completed]="currentStep > 3"></div>

            <div class="step-item" [class.active]="currentStep === 4" [class.completed]="false">
                <div class="step-circle">4</div>
                <div class="step-label">申請完成</div>
            </div>
        </div>

        <!-- ──────────────────────────── Step 1：填寫基本資料 ──────────────────────── -->
        <div class="step-content" *ngIf="currentStep === 1">
            <form>
                <div class="form-item">
                    <label>身分證字號</label>
                    <input type="text" placeholder="請輸入身分證字號" [(ngModel)]="s1IdNumber" name="s1IdNumber" maxlength="10">
                </div>

                <div class="form-item">
                    <label>行動電話</label>
                    <input type="text" placeholder="請輸入行動電話" [(ngModel)]="s1Phone" name="s1Phone" maxlength="10">
                </div>

                <div class="form-item verifcode-row">
                    <input type="text" placeholder="驗證碼" [(ngModel)]="s1VerifCode" name="s1VerifCode" maxlength="20"
                        class="code-input">
                    <button type="button" class="btn-get-code" (click)="getStep1VerifCode()">取得驗證碼</button>
                </div>

                <div class="form-item captcha-row">
                    <input type="text" placeholder="請輸入圖形驗證碼" [(ngModel)]="s1CaptchaCode" name="s1CaptchaCode"
                        maxlength="10" class="code-input captcha-input">
                    <div class="captcha-img-wrap">
                        <img [src]="getSanitizedUrl(s1CaptchaUrl)" alt="圖形驗證碼" class="captcha-img"
                            *ngIf="s1CaptchaUrl" />
                    </div>
                    <img class="refresh-icon" src="/assets/images/refresh.svg" alt="重新整理"
                        (click)="loadStep1Captcha()" />
                </div>

                <div class="form-item checkbox-wrap">
                    <p-checkbox name="s1AgreeChecked" [(ngModel)]="s1AgreeChecked" [binary]="true"
                        inputId="s1AgreeChecked">
                    </p-checkbox>
                    <label for="s1AgreeChecked" class="checkbox-label">
                        我已詳閱．瞭解並同意街口投信
                        <span class="agree-info">「個人資料保護聲明暨告知事項」</span>
                        ，詳情請查閱個人資料蒐集的告知事項。
                    </label>
                </div>

                <p class="error-msg" *ngIf="s1ErrorMsg">{{ s1ErrorMsg }}</p>

                <div class="btn-wrap">
                    <button type="button" class="btn-submit" (click)="step1Submit()">開始申請</button>
                </div>
            </form>
        </div>

        <!-- ──────────────────────────── Step 2：身份驗證 ─────────────────────────── -->
        <div class="step-content" *ngIf="currentStep === 2">
            <div class="id-card-hint">
                <p class="hint-title">請輸入身分證正面相關資訊</p>
                <div class="id-card-ref">
                    <div class="id-card-diagram">
                        <div class="id-card-sample">
                            <img src="../../../../assets/images/ccid_taiwan.jpg" alt="身分證示意圖" class="id-card-img">
                        </div>
                    </div>
                </div>
            </div>

            <form>
                <div class="section-title-row">
                    <h3 class="section-title">身分驗證</h3>
                    <p class="section-title-id">身分證字號：{{ s1IdNumber || '尚未填寫' }}</p>
                </div>

                <div class="form-item">
                    <label>發證日期（年月日）</label>
                    <input type="text" placeholder="例：1100101" [(ngModel)]="s2IssueDate" name="s2IssueDate"
                        maxlength="7">
                </div>

                <div class="form-item">
                    <label>發證地點</label>
                    <p-dropdown [options]="issueSiteList" [(ngModel)]="s2IssueLocation" optionLabel="label"
                        optionValue="value" placeholder="請選擇" name="s2IssueLocation" [style]="{'width':'100%'}">
                    </p-dropdown>
                </div>

                <div class="form-item">
                    <label>領補換類別</label>
                    <p-dropdown [options]="issueCategoryList" [(ngModel)]="s2IssueCategory" optionLabel="label"
                        optionValue="value" placeholder="請選擇" name="s2IssueCategory" [style]="{'width':'100%'}">
                    </p-dropdown>
                </div>

                <p class="error-msg" *ngIf="s2ErrorMsg">{{ s2ErrorMsg }}</p>

                <div class="btn-wrap">
                    <button type="button" class="btn-submit" [disabled]="s2Validating" (click)="step2Submit()">
                        <span *ngIf="!s2Validating">下一步</span>
                        <span *ngIf="s2Validating">驗證中…</span>
                    </button>
                </div>
            </form>
        </div>

        <!-- ──────────────────────── Step 3：申請電子帳單 ─────────────────────────── -->
        <div class="step-content" *ngIf="currentStep === 3">
            <form>
                <h3 class="section-title">申請電子帳單</h3>

                <div class="step3-card">
                    <div class="form-item">
                        <label>Email</label>
                        <input type="email" placeholder="請輸入您的 Email" [(ngModel)]="s3Email" name="s3Email">
                    </div>

                    <div class="form-item captcha-row">
                        <input type="text" placeholder="圖形驗證" [(ngModel)]="s3CaptchaCode" name="s3CaptchaCode"
                            maxlength="10" class="captcha-input">
                        <div class="captcha-img-wrap">
                            <img [src]="getSanitizedUrl(s3CaptchaUrl)" alt="圖形驗證碼" class="captcha-img"
                                *ngIf="s3CaptchaUrl" />
                        </div>
                        <img class="refresh-icon" src="/assets/images/refresh.svg" alt="重新整理"
                            (click)="loadStep3Captcha()" />
                    </div>

                    <div class="form-item verifcode-row">
                        <input type="text" placeholder="Email 驗證碼" [(ngModel)]="s3VerifCode" name="s3VerifCode" maxlength="10">
                        <button type="button" class="btn-get-code" [disabled]="s3Submitting" (click)="getStep3EmailCode()">取得驗證碼</button>
                    </div>

                </div>

                <p class="error-msg" *ngIf="s3ErrorMsg">{{ s3ErrorMsg }}</p>

                <div class="btn-wrap">
                    <button type="button" class="btn-submit" (click)="step3Next()">下一步</button>
                </div>
            </form>
        </div>

        <!-- ─────────────────────── Step 3 確認送出對話框 ─────────────────────────── -->
        <div class="confirm-overlay" *ngIf="s3ShowConfirm">
            <div class="confirm-dialog">
                <h3 class="confirm-title">確認申請資料</h3>

                <div class="confirm-content">
                    <div class="confirm-item">
                        <p class="confirm-etf-label">Email：<strong>{{ s3Email }}</strong></p>
                    </div>
                </div>

                <div class="confirm-warning">
                    <p>送出後將以此 Email 做為電子帳單寄送信箱，請再次確認資料正確。</p>
                </div>

                <div class="confirm-btn-wrap">
                    <button type="button" class="btn-cancel" (click)="step3ConfirmCancel()">返回修改</button>
                    <button type="button" class="btn-submit" [disabled]="s3Submitting" (click)="step3Submit()">
                        <span *ngIf="!s3Submitting">確認送出</span>
                        <span *ngIf="s3Submitting">送出中…</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- ───────────────────────────── Step 4：申請完成 ────────────────────────── -->
        <div class="step-content step-complete" *ngIf="currentStep === 4">
            <div class="complete-icon">✓</div>
            <h2 class="complete-title">申請完成</h2>
            <p class="complete-msg">您的電子帳單申請已成功送出，<br>我們將盡快為您處理。</p>
            <div class="btn-wrap">
                <button type="button" class="btn-submit" (click)="reset()">返回首頁</button>
            </div>
        </div>

    </main>
</div>